import React from "react";
import { BaseComponent } from "../core/BaseComponent";
export class EmployeeGroupListTableHeader extends BaseComponent {
    render() {
        return <thead><tr>
            <td className="dagcellHeader">{this.translate("employeegroup.description")}</td>
            <td className="dagcellHeader">{this.translate("employeegroup.sortorder")}</td>
            <td className="dagcellHeader">{this.translate("employeegroup.amount-linked-employees")}</td>
            <td className="dagcellHeader">&nbsp;</td>
        </tr>
        </thead>;
    }
}
